var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.stopTimer)?_c('p',{staticClass:"countdown",class:_vm.requestTimer.remaining < 10 ? 'warnning' : '',domProps:{"innerHTML":_vm._s(_vm.$t('pin.countdown', { sec: _vm.requestTimer.remaining }))}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }